module.exports = __webpack_public_path__ + "img/ANZ1.57736cd9.svg";